<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="用户id" prop="userId" >-->
<!--        <a-input v-model="form.userId" placeholder="请输入用户id" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="店铺id" prop="shopId" >-->
<!--        <a-input v-model="form.shopId" placeholder="请输入店铺id" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="提现金额" prop="money" >
        <a-input v-model="form.money" disabled placeholder="请输入提现金额" />
      </a-form-model-item>
      <a-form-model-item label="提现手续费" prop="serviceChargeNum" >
        <a-input v-model="form.serviceChargeNum" disabled placeholder="请输入提现手续费" />
      </a-form-model-item>
      <a-form-model-item label="实际需要转账金额" prop="realMoney" >
        <a-input v-model="form.realMoney" disabled placeholder="请输入实际需要转账金额" />
      </a-form-model-item>
<!--      <a-form-model-item label="0-余额 1-保证金" prop="type" >-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="提现方式" prop="withdrawType" >
        <a-select v-model="form.withdrawType" placeholder="请选择提现方式" disabled>
          <a-select-option key="1">支付宝</a-select-option>
          <a-select-option key="2">微信</a-select-option>
          <a-select-option key="3">银行</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="提现账号" prop="accountNum" v-if="form.withdrawType == 1 || form.withdrawType == 2">
        <a-input v-model="form.accountNum" disabled placeholder="请输入提现账号" />
      </a-form-model-item>
      <a-form-model-item label="提现账号姓名" prop="accountName"  v-if="form.withdrawType == 1 || form.withdrawType == 2">
        <a-input v-model="form.accountName" disabled placeholder="请输入提现账号姓名" />
      </a-form-model-item>

      <a-form-model-item label="银行卡号" prop="accountNum" v-if="form.withdrawType == 3">
        <a-input v-model="form.accountNum" disabled placeholder="请输入提现账号" />
      </a-form-model-item>
      <a-form-model-item label="银行名称" prop="bankName" v-if="form.withdrawType == 3">
        <a-input v-model="form.bankName" disabled placeholder="请输入银行名称" />
      </a-form-model-item>
      <a-form-model-item label="银行卡开户行地址" prop="bankAdress" v-if="form.withdrawType == 3">
        <a-input v-model="form.bankAdress" disabled placeholder="请输入银行卡开户行地址" />
      </a-form-model-item>


<!--      <a-form-model-item label="1：普通用户" prop="withdrawUserType" >-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="第三方订单号(微信或支付的交易单号)" prop="orderNo" >-->
<!--        <a-input v-model="form.orderNo" placeholder="请输入第三方订单号(微信或支付的交易单号)" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="失败原因" prop="failureReason" >-->
<!--        <a-input v-model="form.failureReason" placeholder="请输入失败原因" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="审核状态" prop="status" >
        <a-select v-model="form.status" placeholder="请选择审核状态">
<!--          <a-select-option key="0">待审核</a-select-option>-->
          <a-select-option key="1">审核驳回</a-select-option>
          <a-select-option key="2">审核通过</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="审核意见" prop="auditOpinion" v-if="form.status == '1'">
        <a-input v-model="form.auditOpinion" placeholder="请输入审核意见" />
      </a-form-model-item>
<!--      <a-form-model-item label="收款二维码" prop="qrCode" >-->
<!--        <a-input v-model="form.qrCode" placeholder="请输入收款二维码" />-->
<!--      </a-form-model-item>-->

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getWithdrawal, addWithdrawal, updateWithdrawal } from '@/api/user/withdrawal'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        shopId: null,

        money: null,

        realMoney: null,

        type: null,

        status: '0',

        accountNum: null,

        accountName: null,

        serviceChargeNum: null,

        withdrawType: null,

        withdrawUserType: null,

        orderNo: null,

        failureReason: null,

        auditOpinion: null,

        qrCode: null,

        bankName: null,

        bankAdress: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        shopId: null,
        money: null,
        realMoney: null,
        type: null,
        status: '0',
        accountNum: null,
        accountName: null,
        serviceChargeNum: null,
        withdrawType: null,
        withdrawUserType: null,
        orderNo: null,
        failureReason: null,
        auditOpinion: null,
        qrCode: null,
        bankName: null,
        bankAdress: null,
        createTime: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getWithdrawal({"id":id}).then(response => {
        this.form = response.data
        this.form.status = "2";
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateWithdrawal(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addWithdrawal(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
